// Derives the full-res imgix URL from any src by stripping the low-res size params (w=200&q=30).
// For already-full-res URLs the deletion is a no-op. For non-imgix static URLs these params don't
// exist, so it is also a no-op.
export function toPrintSrc(src: string): string {
  try {
    const url = new URL(src);
    url.searchParams.delete('w');
    url.searchParams.delete('q');

    return url.toString();
  } catch {
    return src;
  }
}
